const Footer = () => {
    return (
        <footer className="footer">
            <p>© Lauren Abramsky 2025</p>
        </footer>
    );
};

export default Footer;

